import { InputLabel } from '@mui/material';
import dayjs from 'dayjs';
import useModal from 'hooks/useModal/useModal';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import AlertStatus from 'ui/atoms/AlertStatus/AlertStatus';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface Props {
  activeSinceDate: dayjs.Dayjs;
}

const MyProfileStatusConnected: React.FC<React.PropsWithChildren<Props>> = () => {
  const { translation } = useTranslation();
  const { showModal } = useModal();

  return (
    <ComponentWrapper flexDirection="column" gap="1rem">
      <ComponentWrapper flexDirection="column" gap="0.625rem">
        <InputLabel>{translation.atlas_access_app}</InputLabel>
        <AlertStatus
          id="atlas-access-app-status"
          isConnected
          buttonText={translation.disconnect_device}
          onClick={() => showModal({ type: 'disconnectMobileDevice' })}
        />
      </ComponentWrapper>
    </ComponentWrapper>
  );
};
export default MyProfileStatusConnected;
